import styled from "styled-components";
import { theme } from "../../utils/globalStyles/colors";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 24px 16px 0; /* o espaço do menu inferior fica no BodyContainer */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

/* Menu de abas segmentado (mesmo visual da Carteira) */
export const TabContainer = styled.div`
  display: flex;
  background-color: #e9ecef;
  border-radius: 12px;
  padding: 4px;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
  font-size: 13px;
  background-color: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
  box-shadow: ${({ $active }) =>
    $active ? "0 2px 8px rgba(0,0,0,0.1)" : "none"};
  color: ${({ $active }) => ($active ? theme.colors.base : "#888888")};
  transition: all 0.2s ease;

  & svg {
    font-size: 18px;
  }
`;

export const Count = styled.span<{ $active: boolean }>`
  font-size: 11px;
  font-weight: 800;
  min-width: 18px;
  padding: 1px 6px;
  border-radius: 999px;
  box-sizing: border-box;
  text-align: center;
  color: ${({ $active }) => ($active ? "#ffffff" : "#888888")};
  background-color: ${({ $active }) =>
    $active ? theme.colors.base : "rgba(0, 0, 0, 0.08)"};
`;

export const ListContactsIcon = styled(PeopleIcon)``;

export const AddContactsIcon = styled(PersonAddIcon)``;
